import React, { useEffect, useState } from "react";
import styles from './SingleLineHeaderContainer.module.scss';
import { withRouter } from "next/router";
import HK from "factory/modules/HK";
import * as UI from 'Atom/UI/Icons';
import config from "factory/modules/config";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CARTAction, MenuNodeAction, userRoleAction } from "../action";
import { showAddressFormAction } from "components/Address/action";
import { headerTextAction, singleLineHeader } from "./action";
import { convertToModule } from "factory/utils/clientUtils";
import MenuStrip from "../desktop/MenuStrip";
import Search from '../contains/Search';
import Cart from '../contains/Cart';
import SearchBox from "../contains/SearchBox";
import { isLoginPopupAction } from 'components/common/login/action';
import LoyalityInfoPopup from "components/Loyality/PDP/LoyalityInfoPopup";
import UniversalAnalytics from "factory/modules/UniversalAnalytics";
import { __getLoyaltyIconrender } from "factory/modules/HK_service";


const SingleLineHeaderContainer = (props) => {
    const [searchText, setSearchText] = useState('');
    const [isExpressCheckout, setIsExpressCheckout] = useState(false);
    const [addPremiumPopup, setAddPremiumPopup] = useState(false);

    const desktopPageTypeList = [
        config.pageTypes.cart,
        config.pageTypes.address.selectAddress,
        config.pageTypes.payment.selectPayment,
        config.pageTypes.orderSuccess,
        config.pageTypes.checkout,
        config.pageTypes.plp.menuLanding,
    ];

    const cartViewConfig = [
        config.pageTypes.cart,
        config.pageTypes.payment.selectPayment,
        config.pageTypes.orderSuccess,
        config.pageTypes.checkout
    ];


    const handleSearchText = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        if (props._MenuData && props._MenuData.tpMenuNode && props._MenuData.tpMenuNode.length > 0) {
            return;
        }
        HK.ajaxCall({
            url: config.APIS.menu.headerMenu,
            method: "GET"
        }).then(res => {
            if (res && res.data && res.data.results && !res.data.results.exception) {
                props._MenuNodeAction(res.data.results);
            }
        }).catch(() => { });
        if (HK.loggedIn() || localStorage.getItem('isTMPUser') || HK.Cookies.get('assumeAuth')) {
            fetchCart();
        }
        if (HK.getSearchParmas() && HK.getSearchParmas().txtQ) {
            setSearchText(HK.getSearchParmas().txtQ);
        }

        setIsExpressCheckout(HK.isExpressCheckout() || HK.getSearchParmas().expressCheckout);
    }, []);

    function fetchCart() {
        HK.ajaxCall({
            url: HK.config.APIS.cart.summary,
            method: "GET"
        }).then(res => {
            const _res = res && res.data && res.data.results;
            if (_res && !_res.exception) {
                props._CARTAction(_res);
                props._userRoleAction(_res.hkUserLoyaltyDetailsDto && _res.hkUserLoyaltyDetailsDto.role);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    const navigateBack = () => {
        if (props._showAddressFormReducer && props.isMobile) {
            props._showAddressFormAction(false);
            props._headerTextAction(null);
            props._singleLineHeader(false);
            if (props.pageType === config.pageTypes.checkout) {
                props._singleLineHeader(true);
                props._headerTextAction('CHOOSE AN ADDRESS');
            }
        }
        else if (window.location.href.indexOf("/gateway/response") > -1) {
            props.router.push("/"); //todoN
        }
        else {
            props.router.back();
        }
    };

    const createTempUser = () => {
        if (!(localStorage.getItem('isUserLoggedIn') !== null && localStorage.getItem('isUserLoggedIn') !== 'false' && HK.Cookies.get('authtoken'))) {
            let reqObj = {
                method: 'get',
                url: HK.config.APIS.userFlow.tempUserCreate
            };
            HK.ajaxCall(reqObj).then((res) => {
                const _res = res && res.data && res.data.results;
                if (_res && !_res.exception) {
                    HK.Cookies.set('authtoken', '"' + _res.authToken + '"', 365);
                    localStorage.setItem('isUserLoggedIn', _res.user.id);
                    localStorage.setItem('isTMPUser', 1);
                    HK.setCookieLoggedIn(_res.user.id, 1);
                    handleLoyaltyClick();
                }
            }).catch(err => {
                HK.errorPopup("Something went wrong, please try again.", 'Got: exception::' + reqObj.url);
                HK.reportErrorToDashboard({
                    stackTrace: new Error().stack,
                    errorMessage: err
                });
            });
        }
        else {
            handleLoyaltyClick();
        }
    };


    const handleLoyaltyClick = () => {
        if (props._userRoleReducer !== config.LOYALITY_ROLES.PREMIUM_USER) {
            setAddPremiumPopup(true);
        } else {
            props.router.push("/loyalty");
        }
        let data = {
            event_name: 'select_promotion',
            'reward_points_available': '',
            'value': '',
            'promotion_name': '',
            'creative_name': '',
            'creative_slot': '',
            items: [
                {
                    'item_name': 'Icon_click',
                    'promotion_name': 'Loyalty Feature'
                }
            ]
        };
        UniversalAnalytics.LoyaltyDataLayer(data);
    };


    const getTitleOfPage = () => {
        let pageType = props.pageType;
        if (pageType === config.pageTypes.plp.search) {
            return HK.getSearchParmas().txtQ;
        } else if (pageType === config.pageTypes.ourStory) {
            return 'Our Story';
        } else if (pageType === config.pageTypes.offers) {
            return 'Offers';
        } else if (pageType === config.pageTypes.ContactUs) {
            return 'Contact Us';
        }
        else {
            return props._headerText;
        }
    };

    const showLoginPopUP = () => {
        props._isLoginPopupAction({ isShow: true });
    };
    const RenderAccountButton = () => {
        if (!props._isLoggedIn) {
            return (
                <div className={convertToModule(styles, "menu-logo-container")}>
                    <a onClick={() => showLoginPopUP()} class="header__icon header__icon--account link link--text header-account-icon" >
                        <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
                            <path d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3334 12.5H6.66671C5.78265 12.5 4.93481 12.8512 4.30968 13.4763C3.68456 14.1014 3.33337 14.9493 3.33337 15.8333V17.5" stroke="#002140" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z" stroke="#002140" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </a>
                </div>);
        }
    };

    return (
        <>
            {!props.isMobile
                ? (props._singleHeaderReducer || desktopPageTypeList.includes(props.pageType))
                    ?
                    (<div className={convertToModule(styles, "single-line-header")}>
                        <div className={convertToModule(styles, "tbs-pagecontainer-1170")}>
                            <div className={convertToModule(styles, "flex space-between flex-v-center")}>
                                <div className={convertToModule(styles, "tbs-header-section-left")}>
                                    <a className={convertToModule(styles, "tbs-header-logo footer-logo")} href="/">
                                        <UI.Logo></UI.Logo>
                                    </a>
                                </div>
                                {props._pageType !== "selectAddress" && <div className={convertToModule(styles, "tbs-header-section-right flex width_auto")}>
                                    <img src={HK.getImage("/Gritzo/Common/securePaymentIcon.svg")} alt="securePaymentIcon.svg" />
                                    <span>100% Safe &amp; <br /> Secure Payment </span>
                                </div>}
                            </div>
                        </div>
                    </div>)
                    : ""
                :
                props._searchActiveReducer ?
                    <SearchBox closeButton={true} handleTextChange={handleSearchText} searchText={searchText} />
                    :
                    <div className={styles['header-cntnr-parent']}>
                        {props._menuPromotionalDataReducer && <MenuStrip promotionData={props._menuPromotionalDataReducer} />}
                        <div className={styles['slh-left-cntnr']}>
                            <img src={HK.getImage('/common/menu/navigate_back.svg')} alt="back-nav-btn.svg" className={convertToModule(styles, "SLH__back-btn")} onClick={() => navigateBack()} />
                            <div className={styles['header-ttl']}>
                                {getTitleOfPage()}
                            </div>
                        </div>
                        {props.isOnlyTitle ? <></> : <>
                            {!isExpressCheckout ?
                                <div className={styles['slh-right-cntnr']}>
                                    {
                                        __getLoyaltyIconrender(props._pageType) ?
                                            <div className={convertToModule(styles, "menu-search-container")}>
                                                <svg width="24" height="19" viewBox="0 0 24 19" fill="none" onClick={() => createTempUser()}>
                                                    <path d="M23.1831 6.30994L23.1821 6.30805L20.2113 0.989836L20.2113 0.989833L20.2105 0.988352C20.1283 0.843645 19.9737 0.756491 19.806 0.761161L4.19073 0.760083C4.03007 0.757008 3.87353 0.839836 3.78888 0.984736L3.78884 0.984714L3.78658 0.988775L0.82019 6.30028C0.817362 6.30486 0.814766 6.30939 0.812383 6.31385C0.809769 6.31812 0.807222 6.32257 0.804764 6.32722C0.800178 6.3359 0.796305 6.34448 0.793041 6.35289C0.781533 6.37956 0.774704 6.40443 0.770378 6.42558L0.776964 6.42693L0.770378 6.42559C0.765088 6.45146 0.76 6.48463 0.76 6.5222C0.76 6.56598 0.766993 6.60803 0.779358 6.64662C0.786936 6.67284 0.801095 6.71692 0.832559 6.76308L0.832249 6.76329L0.840419 6.77395C0.84225 6.77634 0.844077 6.77863 0.845887 6.78083C0.854326 6.79507 0.866592 6.81281 0.884078 6.83074L11.6536 18.0784L11.659 18.0872L11.6802 18.1079C11.703 18.1302 11.7253 18.1475 11.7455 18.1614L11.7703 18.1783L11.7812 18.1823C11.7914 18.1887 11.801 18.1936 11.8095 18.1975C11.8262 18.2052 11.8407 18.2095 11.8478 18.2115C11.8523 18.213 11.8561 18.2142 11.8584 18.215L11.8591 18.2152C11.8621 18.2162 11.8632 18.2166 11.8635 18.2167L11.8635 18.2168L11.8718 18.2195C11.9126 18.2328 11.9575 18.24 12.0013 18.24C12.0411 18.24 12.0763 18.2344 12.1067 18.2271C12.123 18.2241 12.1346 18.2206 12.1388 18.2193C12.1518 18.2154 12.1625 18.2112 12.1671 18.2095L12.2125 18.1917L12.2191 18.1852C12.2276 18.181 12.2353 18.1766 12.2422 18.1722C12.2493 18.168 12.2556 18.1638 12.2611 18.1599C12.2616 18.1596 12.262 18.1593 12.2625 18.159L12.2824 18.146L12.2992 18.1296C12.3225 18.1119 12.337 18.0944 12.3434 18.0865C12.3448 18.0847 12.3461 18.083 12.3472 18.0815L23.1163 6.83394L23.1244 6.82549L23.1287 6.82003L23.1306 6.81799L23.1377 6.81036C23.1478 6.79932 23.1709 6.7736 23.1899 6.73597L23.1918 6.7323C23.1926 6.7308 23.1938 6.7287 23.1951 6.72617C23.1968 6.72288 23.1989 6.71885 23.2011 6.71448C23.2058 6.7048 23.2153 6.68484 23.2227 6.65839C23.2286 6.64046 23.2354 6.61464 23.2374 6.58336C23.246 6.4997 23.2341 6.40319 23.1831 6.30994ZM13.0837 1.64789H19.1255L17.2534 5.75743L13.0837 1.64789ZM17.6779 6.96599H21.7466L13.6075 15.4719L17.6779 6.96599ZM16.3088 6.07932H11.9987H7.68869L11.9987 1.82917L16.3088 6.07932ZM6.31939 6.96599L10.3907 15.4708L2.25073 6.96599H6.31939ZM4.87413 1.64789H10.9136L6.74617 5.75526L4.87413 1.64789ZM20.2861 2.9594L20.2862 2.9595L22.0278 6.07932H18.0898L19.8599 2.19507L20.2861 2.9594ZM7.31236 6.96604H16.6861L11.9987 16.7616L7.31236 6.96604ZM1.96995 6.07948L4.13857 2.19651L5.91071 6.07948H1.96995Z" fill="#E57321" stroke="#E57321" stroke-width="0.48" />
                                                </svg>
                                            </div>
                                            : <></>
                                    }
                                    {!cartViewConfig.includes(props._pageType) ?
                                        <>
                                            <Search />
                                            <Cart CART={props._CARTReducer} />
                                        </>
                                        :
                                        <>
                                            {RenderAccountButton()}
                                        </>
                                    }
                                </div>
                                : <></>
                            }
                        </>}

                    </div>
            }
            {
                addPremiumPopup ?
                    <LoyalityInfoPopup setAddPremiumPopup={setAddPremiumPopup} />
                    : <></>
            }
        </>
    );

};
function mapStateToProps(state) {
    return {
        _pageType: state.pageTypeReducer,
        _headerText: state.headerTextReducer,
        _singleHeaderReducer: state.singleLineHeaderReducer,
        _searchActiveReducer: state.searchActiveReducer,
        _showAddressFormReducer: state.showAddressFormReducer,
        _MenuData: state.MenuData,
        _menuPromotionalDataReducer: state.menuPromotionalDataReducer,
        _CARTReducer: state.CARTReducer,
        _userRoleReducer: state.userRoleReducer,
        _isLoggedIn: state.isLogedInReducer,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        _showAddressFormAction: showAddressFormAction,
        _singleLineHeader: singleLineHeader,
        _headerTextAction: headerTextAction,
        _MenuNodeAction: MenuNodeAction,
        _CARTAction: CARTAction,
        _userRoleAction: userRoleAction,
        _isLoginPopupAction: isLoginPopupAction,
    }, dispatch);
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SingleLineHeaderContainer)
);